import { render, staticRenderFns } from "./DocumentValidityEditor.vue?vue&type=template&id=a95f03ba"
import script from "./DocumentValidityEditor.vue?vue&type=script&lang=js"
export * from "./DocumentValidityEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports